import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { LoadingStore } from './loading.store';

/**
 * Service to set the loading state in elf store for custom keys
 * @example Set the loading state for user-list
 * this.api.get(endpoint).pipe(first(), this.loader.set('user-list'));
 * <app-loading-spinner key="user-list"></app-loading-spinner>
 *
 * @example Get the loading state for user-create
 * public loading = this.loadingService.get('user-create');
 * <button mat-button [disabled]="this.form.invalid || (loading | async)">Save</button>
 */

@Injectable({ providedIn: 'root' })
export class LoadingService {
  constructor(private store: LoadingStore) {
  }

  get(key: string): Observable<boolean> {
    return this.store.select(key);
  }

  set(key: string) {
    return (source: any) => {
      this.store.update(key, true);
      return source.pipe(finalize(() => this.store.update(key, false)));
    };
  }
}
